module.exports = "<button type=\"button\" class=\"layui-btn\" id=\"{{fieldName}}\">\r\n    <i class=\"layui-icon\">&#xe67c;</i>上传文件\r\n</button>";


//////////////////
// WEBPACK FOOTER
// ./src/template/form/UploadFile.html
// module id = 76
// module chunks = 0